import React from 'react';
import { Skeleton, SkeletonBlock, SkeletonLine, SkeletonContent } from '@one-thd/sui-atomic-components';

export const ProductPlaceholder = () => {

  return (
    <div
      data-testid="product-placeholder"
      className="sui-grid sui-grid-cols-12 sui-justify-center
      sui-m-0 sui-p-0 sui-w-full"
    >
      <div className="sui-col-span-12">
        <Skeleton
          grow
          data-component="ProductPodPlaceholder"
          width="100%"
        >
          <SkeletonBlock aspect="square" width="100%" height="100%" />
          <SkeletonLine variant="multi" numberOfLines={4} fullWidth />
          <SkeletonBlock height={10} aspect="wide" />
        </Skeleton>
      </div>
    </div>
  );
};

ProductPlaceholder.displayName = 'ProductPlaceholder';
